var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.01 0c1.103 0 2 .897 2 2v20c0 1.103-.897 2-2 2H10c-1.103 0-2-.897-2-2v-5a1 1 0 012 0v5h12.01V2H10v5a1 1 0 01-2 0V2c0-1.103.897-2 2-2h12.01zm-9.717 7.293a.999.999 0 011.414 0l4 4a.999.999 0 01.216 1.089.999.999 0 01-.216.325l-4 4a.997.997 0 01-1.414 0 .999.999 0 010-1.414L14.586 13H1a1 1 0 010-2h13.586l-2.293-2.293a.999.999 0 010-1.414z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconLogin;